import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Form } from "../../../base/views/useForm";
import DateFnsUtils from "@date-io/date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import "date-fns";
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  Appcss: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    borderRadius: "15px",
    padding: "30px",
    justifyContent: "center",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(1, 0, 1),
  },
}));

const initialFValues = {
  withlotno: false,
  description: "",
  ndc: "",
  upc: "",
  packsize: "",
  serialno: "",
  expirydate: null,
  lot: "",
  qty: "1",
  comments: "",
  location: "",
  inv_type: "FULL",
};

export default function AddOtcProductForm({
  showPartialFull = false,
  ...props
}) {
  const classes = useStyles();

  const [addOtcProductData, setState] = useState(initialFValues);
  const [errors, setErrors] = React.useState({});

  const { addOrEdit, recordForEdit, addOtcProduct, captureGoodsState } = props;

  const validate = (fieldValues = addOtcProductData) => {
    let temp = { ...errors };

    if ("description" in fieldValues) {
      temp.description =
        fieldValues.description === "" ? "Description is required" : "";
    }

    if ("packsize" in fieldValues) {
      temp.packsize =
        fieldValues.packsize === "" ? "Pack Size is required" : "";
    }

    if (fieldValues.withlotno) {
      if ("expirydate" in fieldValues) {
        temp.expirydate =
          fieldValues.expirydate === null ? "ExpiryDate is required" : "";
      }

      if ("lot" in fieldValues) {
        temp.lot = fieldValues.lot === "" ? "Lot is required" : "";
      }
    }

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const handleDateChange = (date) => {
    setState({
      ...addOtcProductData,
      expirydate: date,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      addOtcProduct({
        ...addOtcProductData,
        captureGoodsState: captureGoodsState,
      });
      addOrEdit(resetForm);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState({
      ...addOtcProductData,
      [name]: value,
    });
  };

  const resetForm = () => {
    setState(initialFValues);
    setErrors({});
  };

  useEffect(() => {
    if (recordForEdit != null) {
      setState({
        ...recordForEdit,
      });
    }
  }, [recordForEdit]);

  return (
    <Form onSubmit={handleSubmit}>
      <Container component="main" maxWidth="sm">
        <div className={classes.form}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <TextField
                autoFocus
                value={addOtcProductData.upc}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="upc"
                label="Upc"
                name="upc"
                autoComplete="upc"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={addOtcProductData.ndc}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="ndc"
                label="NDC"
                name="ndc"
                autoComplete="ndc"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={addOtcProductData.description}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="description"
                label="Description"
                name="description"
                autoComplete="description"
                {...(errors.description && {
                  error: true,
                  helperText: errors.description,
                })}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={addOtcProductData.packsize}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="packsize"
                label="PackSize"
                name="packsize"
                autoComplete="packsize"
                {...(errors.packsize && {
                  error: true,
                  helperText: errors.packsize,
                })}
              />
            </Grid>
            <Grid item xs={6} style={{ marginLeft: "0px" }}>
              <TextField
                value={addOtcProductData.qty}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="qty"
                label="Qty"
                name="qty"
                autoFocus
                autoComplete="qty"
                type="number"
                InputProps={{ inputProps: { min: 1 } }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={addOtcProductData.serialno}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="serialno"
                label="Serial No"
                name="serialno"
                autoComplete="serialno"
                {...(errors.serialno && {
                  error: true,
                  helperText: errors.serialno,
                })}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={addOtcProductData.lot}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="lot"
                label="Lot No."
                name="lot"
                autoComplete="lot"
                {...(errors.lot && {
                  error: true,
                  helperText: errors.lot,
                })}
              />
            </Grid>
            <Grid item xs={6} style={{ marginLeft: "-15px" }}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    name="expirydate"
                    label="Expiry Date"
                    format="MM/dd/yyyy"
                    autoOk={true}
                    okLabel={""}
                    cancelLabel={""}
                    value={addOtcProductData.expirydate}
                    onChange={handleDateChange}
                    className={classes.submit}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    {...(errors.expirydate && {
                      error: true,
                      helperText: errors.expirydate,
                    })}
                  />
                </Grid>
              </MuiPickersUtilsProvider>
            </Grid>
            {showPartialFull && (
              <Grid item xs={12}>
                <RadioGroup
                  row
                  aria-label="scan"
                  name="inv_type"
                  value={addOtcProductData.inv_type}
                  onChange={handleInputChange}
                  tabIndex={-1}
                  style={{
                    border: "",
                    display: "flex",
                    justifyContent: "space-evenly",
                    width: "100%",
                  }}
                >
                  <FormControlLabel
                    value="FULL"
                    control={<Radio style={{ color: "rgb(22, 177, 255)" }} />}
                    label="FULL"
                  />
                  <FormControlLabel
                    value="PARTIAL"
                    control={<Radio style={{ color: "rgb(22, 177, 255)" }} />}
                    label="PARTIAL"
                  />
                </RadioGroup>
              </Grid>
            )}

            <Grid item xs={12}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  style={{
                    width: "20vw",
                    backgroundColor: "rgb(22, 177, 255)",
                    borderRadius: "0.5rem",
                  }}
                  type="submit"
                >
                  Save
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </Container>
    </Form>
  );
}
